<template>
  <div class="share">
    <ShareNetwork
      v-for="social in socials"
      :key="social.label"
      :network="social.label"
      :url="finalUrl"
      :title="title"
      :description="description"
    >
      <UiShareButton
        :label="social.label"
        :picto="`/medias/${social.picto}.svg`"
      />
    </ShareNetwork>
  </div>

  <!-- DEBUG INFOS -->
  <!--div class="app-width-small">
    <mark>Share Infos</mark><br>
    <small>{{ finalUrl }}</small><br>
    <b>{{ title }}</b><br>
    {{ description }}<br>
  </div-->
</template>

<script>
const absolutePath = (u) => {
  const reg = new RegExp(/^https{0,1}:\/\/.*/);
  if (reg.test(u)) { return u }

  if (typeof window !== 'undefined') {
    const { protocol, host } = window.location;
    return `${protocol}//${host}${u}`;
  }

  return u;
};

export default {
  props: {
    title: { type: String, default: null },
    description: { type: String, default: null },
    url: { type: String, default: null },
  },

  computed: {
    socials() {
      return [
        { label: 'twitter', picto: 'picto-social-twitter' },
        { label: 'linkedin', picto: 'picto-social-linkedin' },
      ];
    },

    finalUrl() {
      return absolutePath(this.url || this.$route.path);
    },
  },
};
</script>

<style lang="stylus" scoped>
.share {
  display flex
  justify-content center
  gap 25px
  margin-top 50px
  margin-bottom @margin-top
}
</style>
